export const SET_AD_PREVIEW = 'setAdPreview'
export const SET_LIST_PREVIEW = 'setListPreview'
